/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Achievements_BodyInputs */



/**
* | output |
* | --- |
* | "Roles for leaderboard place, voice time, game playtime, time in the server and invites brought in." |
*
* @param {Features_Achievements_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_achievements_body = /** @type {((inputs?: Features_Achievements_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Achievements_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Роли за место в таблице лидеров, время в голосовых каналах и играх, время на сервере и приглашённых участников.")
	return /** @type {LocalizedString} */ ("Roles for leaderboard place, voice time, game playtime, time in the server and invites brought in.")
});